import { useEffect, useRef, useCallback } from 'react';

// icons
import {
    IoPlaySkipBackSharp,
    IoPlaySkipForwardSharp,
    IoPlaySharp,
    IoPauseSharp,
} from 'react-icons/io5';

const Controls = (props) => {
    const audioRef = props.audioRef;
    const progressBarRef = props.progressBarRef;
    const duration = props.duration;
    const setTimeProgress = props.setTimeProgress;
    const tracks = props.tracks;
    const trackIndex = props.trackIndex;
    const setTrackIndex = props.setTrackIndex;
    const setCurrentTrack = props.setCurrentTrack;
    const handleNext = props.handleNext;
    const isPlaying = props.isPLaying;
    const setIsPlaying = props.setIsPlaying;

    const togglePlayPause = () => {
        setIsPlaying((prev) => !prev);
    };
    const playAnimationRef = useRef();

    const repeat = useCallback(() => {
        const currentTime = audioRef.current.currentTime;
        setTimeProgress(currentTime);
        progressBarRef.current.value = currentTime;
        progressBarRef.current.style.setProperty(
            '--range-progress',
            `${(progressBarRef.current.value / duration) * 100}%`
        );

        playAnimationRef.current = requestAnimationFrame(repeat);
    }, [audioRef, duration, progressBarRef, setTimeProgress]);

    useEffect(() => {
        if (isPlaying) {
            audioRef.current.play();
        } else {
            audioRef.current.pause();
        }
        playAnimationRef.current = requestAnimationFrame(repeat);
    }, [isPlaying, audioRef, repeat]);


    // const skipForward = () => {
    //     audioRef.current.currentTime += 15;
    // };

    // const skipBackward = () => {
    //     audioRef.current.currentTime -= 15;
    // };

    const handlePrevious = () => {
        if (trackIndex === 0) {
            let lastTrackIndex = tracks.length - 1;
            setTrackIndex(lastTrackIndex);
            setCurrentTrack(tracks[lastTrackIndex]);
        } else {
            setTrackIndex((prev) => prev - 1);
            setCurrentTrack(tracks[trackIndex - 1]);
        }
    };



    return (
        <div className="controls-wrapper2">
            <div className="controls">
                <button onClick={handlePrevious} style={{scale:"1.3"}}>
                    <IoPlaySkipBackSharp/>
                </button>
{/*                <button onClick={skipBackward} style={{scale:"1.7"}}>
                    <IoPlayBackSharp/>
                </button>*/}

                <button onClick={togglePlayPause} style={{scale:"2"}}>
                    {isPlaying ? <IoPauseSharp/> : <IoPlaySharp/>}
                </button>
{/*                <button onClick={skipForward} style={{scale:"1.7"}}>
                    <IoPlayForwardSharp/>
                </button>*/}
                <button onClick={handleNext} style={{scale:"1.3"}}>
                    <IoPlaySkipForwardSharp/>
                </button>
            </div>
        </div>
    )
};
export default Controls;